import type { InitializeDepositRequest, InitializeDepositResponse } from './pnpCashier.types';
import { apiClient } from '../../api/swr';
import { API_URL } from '../../utils/envConstants';

export const initializePnpDeposit = async (
  payload: InitializeDepositRequest,
): Promise<InitializeDepositResponse> => {
  const response = await apiClient(
    `${API_URL}/casino-player/pay-and-play-orchestrator/api/pay-and-play/initialize`,
    'POST',
    payload,
  );

  if (!response.ok) {
    throw new Error(`Deposit initialization failed: ${response.status}`);
  }

  return response.json();
};
